var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83325 5.64706H17.1666M8.83325 14.4706V9.17647M12.1666 14.4706V9.17647M13.8333 18H7.16659C6.24611 18 5.49992 17.2099 5.49992 16.2353V6.52941C5.49992 6.0421 5.87301 5.64706 6.33325 5.64706H14.6666C15.1268 5.64706 15.4999 6.0421 15.4999 6.52941V16.2353C15.4999 17.2099 14.7537 18 13.8333 18ZM8.83325 5.64706H12.1666C12.6268 5.64706 12.9999 5.25202 12.9999 4.76471V3.88235C12.9999 3.39504 12.6268 3 12.1666 3H8.83325C8.37301 3 7.99992 3.39504 7.99992 3.88235V4.76471C7.99992 5.25202 8.37301 5.64706 8.83325 5.64706Z",
    stroke: "#FF2C2C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.dd3fa6dd50a61104c105337fc9d33caf.svg";
export { ForwardRef as ReactComponent };